import type { Variants } from 'framer-motion';

/** Section-level stagger container — children reveal one after another. */
export const staggerContainer = (stagger = 0.05): Variants => ({
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { staggerChildren: stagger } },
});

/** Default per-item entrance paired with `staggerContainer`. */
export const staggerItem: Variants = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { type: 'spring', stiffness: 300, damping: 24 } },
};

/** Smaller-travel entrance for compact list rows (timeline rows, table rows). */
export const timelineItemVariants: Variants = {
  hidden: { opacity: 0, y: 10 },
  show: { opacity: 1, y: 0, transition: { type: 'spring', stiffness: 300, damping: 24 } },
};
